import { uniqueId } from 'lodash'
import { addNotification } from 'components/Notifications/actions'

const notifications = ({ t, info }) => ({
  success: {
    create: {
      title: t(`Translations:TRANSLATION_${info}`),
      message: t(`Translations:TRANSLATION_${info}_ADDED`)
    }
  }
  // error: {
  //   error: {
  //     title: t('Translations:ERROR_NEW_TRANSLATION'),
  //     caption: t(`Translations:ERROR_${info}_ADDING`)
  //   }
  // }
})

export const sendNotification = ({ t, kind, action, ...other }) => {
  const notificationMap = notifications({ t, ...other })
  const notification = {
    ...notificationMap[kind][action],
    id: uniqueId('notif-'),
    // type: kind === 'error' ? 'toast' : 'inline',
    kind
  }

  addNotification(notification)
}
